import { useCallback } from 'react'
import { useHotkeys } from 'react-hotkeys-hook'
import { useControlStore } from '@editorStores'
import { useIfcMode } from '@editorHooks'

/**
 * Hotkey "a" toggles the IFC Import scene selection between the planar (structural) model and the
 * IFC/GLB model, mirroring the two "Auswählen (a)" / "Import auswählen (a)" toolbar buttons. Only
 * active outside guided mode (where the guided steps drive the selection mode themselves), matching
 * where those toolbar buttons are shown. react-hotkeys-hook ignores key events from form fields, so
 * "a" stays typeable while editing text.
 */
const useIFCImportSelectionModeHotkey = (): void => {
  const selectionMode = useControlStore(state => state.selectionMode)
  const setSelectionMode = useControlStore(state => state.setSelectionMode)
  const { ifcMode } = useIfcMode()

  const isGuidedActive = ifcMode === 'guided'

  const toggle = useCallback(
    () =>
      setSelectionMode(
        selectionMode === 'planar-model-selection' ? 'ifc-selection' : 'planar-model-selection',
      ),
    [selectionMode, setSelectionMode],
  )

  useHotkeys('a', toggle, { enabled: !isGuidedActive, preventDefault: true }, [toggle])
}

export default useIFCImportSelectionModeHotkey
